import(/* webpackMode: "eager" */ "/app/apps/bidder-web/src/app/global-error.tsx");
